/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Override default lead time (1-168 hours). Uses tenant setting if not specified.
 */
export type LecturerBriefingJobParamsLeadTimeHours = number | null;
